const isRequired = (param, fn) => {
  throw new Error(`${param} is required in ${fn}`);
};

export default isRequired;
